/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 16:01:12
 */
import request from '@/utils/request'

export const queryPage ='/icps/system/sign/basics/pumpUnit/QueryPage'
export const batchUpdateOrDelete ='/icps/system/sign/basics/pumpUnit/deletes'
export const updateSortNum ='/icps/system/sign/basics/pumpUnit/update_sort_num'
export const saveOrUpdate ='/icps/system/sign/basics/pumpUnit/saveOrUpdate'
export const Download ='/icps/system/sign/basics/pumpUnit/exportList'

export function equipmentMaintainsave(data) {
  return request({
    url: '/icps/system/sign/basics/pumpUnitMaintain/save', 
    method: 'post',
	data
  })
}
export function equipmentMaintainQueryPagee(data) {
  return request({
    url: '/icps/system/sign/basics/pumpUnitMaintain/QueryPage', 
    method: 'post',
	data
  })
}

export function typeQuery() {
  return request({
    url: '/icps/system/sign/basics/pumpUnitType/QueryPumpUnitTypes', 
    method: 'post'
  })
}
export function isDeletetype(data) {
  return request({
    url: '/icps/system/sign/basics/pumpUnitType/queryPumpUnitTypeByid', 
    method: 'post',
	data
  })
}
export function typesaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/basics/pumpUnitType/saveOrUpdate', 
    method: 'post',
	data
  })
}
export function QueryPlateNumbersIsUse(data) {
  return request({
    url: '/icps/system/sign/basics/pumpUnit/QueryPlateNumbersIsUse', 
    method: 'post',
	data
  })
}
/**
 * @description 泵车检查项-新增或修改数据
 */
export function setcheckItem(data) {
  return request({
    url: '/icps/system/sign/basics/checkItem/saveOrUpdate', 
    method: 'post',
	data
  })
}
/**
 * @description 泵车检查项-获取检查项列表
 */
export function getListcheckItem(data) {
  return request({
    url: '/icps/system/sign/basics/checkItem/queryList', 
    method: 'post',
	data
  })
}
/**
 * @description 泵车检查项-删除检查项
 * */
export function deletescheckItem(data) {
  return request({
    url: '/icps/system/sign/basics/checkItem/deletes', 
    method: 'post',
	data
  })
}
